import React from "react";
import { Box, useTheme } from "@mui/material";
import { OcRoleFilterSummaryItem } from "oc/components/role-filter-summary-item";

export interface OcRoleFilterSummaryItemI {
  label: string;
  value: string | number | undefined;
  color?: string;
}

interface OcRoleFilterSummaryProps {
  itemsDef: OcRoleFilterSummaryItemI[];
}

export const OcRoleFilterSummary: React.FC<OcRoleFilterSummaryProps> = ({
  itemsDef,
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        padding: "8px 0px",
        border: `1px solid ${theme.palette.gray40.main}`,
        borderRadius: "4px",
      }}
    >
      {itemsDef.map((item) => (
        <OcRoleFilterSummaryItem {...item} key={item.label} />
      ))}
    </Box>
  );
};
